/* eslint-disable @next/next/no-img-element */

import React from 'react';

import { cn } from '~/lib/utils';

interface AvatarWithInitialsProps {
  name: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

// Helper para obter iniciais do nome
const getInitials = (name: string): string => {
  const parts = name.trim().split(' ');
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

export const AvatarWithInitials: React.FC<AvatarWithInitialsProps> = ({
  name,
  src,
  size = 'md',
  className
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6 text-[10px]',
    md: 'w-6 h-6 text-[10px]', // 24x24px
    lg: 'w-12 h-12 text-base'
  };

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={cn(
          'rounded-full object-cover flex-shrink-0',
          sizeClasses[size],
          className
        )}
      />
    );
  }

  return (
    <div
      className={cn(
        'rounded-full bg-gray-200 flex items-center justify-center font-medium text-gray-700 flex-shrink-0',
        sizeClasses[size],
        className
      )}>
      {getInitials(name)}
    </div>
  );
};
